import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { Components, Users, UsersPending, UsersProfile, UsersPermissions, AccessRequest, NewContract, ContractDetails, ExpiredContracts, UsersReport, Monitor, ApprovalsContributions, ApprovalsWithdrawls, ApprovalsContracts, ApprovalsSpirits, ApprovalsSpirit2, ApprovalsSpirit3, ApprovalsBats, Login, Operations, OperationsSpirit2, OperationsSpirit3, OperationsBats, OperationsCapexSenior, OperationsCapexSub, Comissoes, Products, ProductForm, Automacoes, AutomacaoForm, AutomacaoDetail } from '../pages'
import Saques from '../pages/saques'
import { store } from '../redux/store'
import { Provider } from 'react-redux'
import ProtectedRoute from '../components/ProtectedRoute'

const RouterWrapper = () => {
    return (
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <Provider store={store}>
                <Routes>
                    <Route exact sensitive path="/" element={<Navigate to="/login" />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/components" element={
                        <ProtectedRoute>
                            <Components />
                        </ProtectedRoute>
                    } />
                    <Route path="/clientes/geral" element={
                        <ProtectedRoute>
                            <Users />
                        </ProtectedRoute>
                    } />
                    <Route path="/clientes/pendentes" element={
                        <ProtectedRoute>
                            <UsersPending />
                        </ProtectedRoute>
                    } />
                    <Route path="/cliente/:id" element={
                        <ProtectedRoute>
                            <UsersProfile />
                        </ProtectedRoute>
                    } />
                    <Route path="/contrato/:id" element={
                        <ProtectedRoute>
                            <ContractDetails />
                        </ProtectedRoute>
                    } />
                    <Route path="/cliente/:id/novo-contrato/" element={
                        <ProtectedRoute>
                            <NewContract />
                        </ProtectedRoute>
                    } />
                    <Route path="/cliente/:id/permissoes" element={
                        <ProtectedRoute resourceKey="permission_management">
                            <UsersPermissions />
                        </ProtectedRoute>
                    } />
                    <Route path="/acesso/solicitar" element={<AccessRequest />} />
                    <Route path="/clientes/relatorio/" element={
                        <ProtectedRoute>
                            <UsersReport />
                        </ProtectedRoute>
                    } />
                    <Route path="/contratos/vencidos/" element={
                        <ProtectedRoute>
                            <ExpiredContracts />
                        </ProtectedRoute>
                    } />
                    <Route path="/monitor" element={
                        <ProtectedRoute>
                            <Monitor />
                        </ProtectedRoute>
                    } />
                    <Route path="/aprovacoes/aportes" element={
                        <ProtectedRoute>
                            <ApprovalsContributions />
                        </ProtectedRoute>
                    } />
                    <Route path="/aprovacoes/resgates" element={
                        <ProtectedRoute>
                            <ApprovalsWithdrawls />
                        </ProtectedRoute>
                    } />
                    <Route path="/aprovacoes/asa" element={
                        <ProtectedRoute>
                            <ApprovalsContracts />
                        </ProtectedRoute>
                    } />
                    <Route path="/aprovacoes/spirit" element={
                        <ProtectedRoute>
                            <ApprovalsSpirits />
                        </ProtectedRoute>
                    } />
                    <Route path="/aprovacoes/spirit2" element={
                        <ProtectedRoute>
                            <ApprovalsSpirit2 />
                        </ProtectedRoute>
                    } />
                    <Route path="/aprovacoes/spirit3" element={
                        <ProtectedRoute>
                            <ApprovalsSpirit3 />
                        </ProtectedRoute>
                    } />
                    <Route path="/aprovacoes/bats" element={
                        <ProtectedRoute>
                            <ApprovalsBats />
                        </ProtectedRoute>
                    } />
                    <Route path="/operacional-spirit2" element={<Navigate to="/operacional/spirit2" replace />} />
                    <Route path="/operacional/spirit2" element={
                        <ProtectedRoute>
                            <OperationsSpirit2 />
                        </ProtectedRoute>
                    } />
                    <Route path="/operacional-spirit3" element={<Navigate to="/operacional/spirit3" replace />} />
                    <Route path="/operacional/spirit3" element={
                        <ProtectedRoute>
                            <OperationsSpirit3 />
                        </ProtectedRoute>
                    } />
                    <Route path="/operacional/capex-senior" element={
                        <ProtectedRoute>
                            <OperationsCapexSenior />
                        </ProtectedRoute>
                    } />
                    <Route path="/operacional/capex-sub" element={
                        <ProtectedRoute>
                            <OperationsCapexSub />
                        </ProtectedRoute>
                    } />
                    <Route path="/operacional/bats" element={
                        <ProtectedRoute>
                            <OperationsBats />
                        </ProtectedRoute>
                    } />
                    <Route path="/operacional/:id" element={
                        <ProtectedRoute>
                            <Operations />
                        </ProtectedRoute>
                    } />
                    <Route path="/wallet/conversoes" element={
                        <ProtectedRoute>
                            <Users />
                        </ProtectedRoute>
                    } />
                    <Route path="/wallet/tokens-aprovacao" element={
                        <ProtectedRoute>
                            <Users />
                        </ProtectedRoute>
                    } />
                    <Route path="/comissoes" element={
                        <ProtectedRoute>
                            <Comissoes />
                        </ProtectedRoute>
                    } />
                    <Route path="/saques" element={
                        <ProtectedRoute>
                            <Saques />
                        </ProtectedRoute>
                    } />
                    <Route path="/saques/historico" element={
                        <ProtectedRoute>
                            <Saques />
                        </ProtectedRoute>
                    } />
                    <Route path="/produtos" element={
                        <ProtectedRoute>
                            <Products />
                        </ProtectedRoute>
                    } />
                    <Route path="/produtos/novo" element={
                        <ProtectedRoute>
                            <ProductForm />
                        </ProtectedRoute>
                    } />
                    <Route path="/produtos/:id" element={
                        <ProtectedRoute>
                            <ProductForm />
                        </ProtectedRoute>
                    } />
                    <Route path="/automacoes" element={
                        <ProtectedRoute>
                            <Automacoes />
                        </ProtectedRoute>
                    } />
                    <Route path="/automacoes/nova" element={
                        <ProtectedRoute>
                            <AutomacaoForm />
                        </ProtectedRoute>
                    } />
                    <Route path="/automacoes/:id" element={
                        <ProtectedRoute>
                            <AutomacaoDetail />
                        </ProtectedRoute>
                    } />
                </Routes>
            </Provider>
        </Router>
    )
}

export default RouterWrapper